package dev.lingvo.site.components.studio.preview

import dev.lingvo.site.api.ApiClient
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import org.w3c.dom.HTMLCanvasElement
import kotlin.js.Promise

/** Limits local icon analysis to 64×64 pixels and always releases the decoded bitmap. */
suspend fun projectIconPixels(slug: String): IntArray {
    val blob = ApiClient.projectIcon(slug)
    val image = previewBitmap(blob, "project-icon:$slug", 64, 64)
    val canvas = document.createElement("canvas") as HTMLCanvasElement
    canvas.width = 64
    canvas.height = 64
    try {
        val context = canvas.getContext("2d").asDynamic()
        context.drawImage(image.bitmap, 0, 0, 64, 64)
        val data = context.getImageData(0, 0, 64, 64).data
        return IntArray(64 * 64 * 4) { (data[it] as Number).toInt() }
    } finally {
        image.close()
        canvas.width = 0
        canvas.height = 0
    }
}
